<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocf"><a class="xref" href="#/chicondon0006#ch01">1   The Politics of Social Comparison</a></p>
<p class="tocpt"><a class="xref" href="#/chicondon0007#pt01"><span class="sm">PART</span> <span class="sm">I</span>   Imagining the Economic Other</a></p>
<p class="toc"><a class="xref" href="#/chicondon0008#ch02">2   Inequality in the Social Mind</a></p>
<p class="toc"><a class="xref" href="#/chicondon0009#ch03">3   Revealing the Social Mind</a></p>
<p class="toc"><a class="xref" href="#/chicondon0010#ch04">4   The Disadvantaged Other</a></p>
<p class="toc"><a class="xref" href="#/chicondon0011#ch05">5   The Advantaged Other</a></p>
<p class="tocpt"><a class="xref" href="#/chicondon0012#pt02"><span class="sm">PART</span> <span class="sm">II</span>   Responding to the Economic Other</a></p>
<p class="toc"><a class="xref" href="#/chicondon0013#ch06">6   Social Comparison and Status Perceptions</a></p>
<p class="toc"><a class="xref" href="#/chicondon0014#ch07">7   Social Comparison and Support for Redistribution</a></p>
<p class="tocpt"><a class="xref" href="#/chicondon0015#pt03"><span class="sm">PART</span> <span class="sm">III</span>   Insulated from Inequality</a></p>
<p class="toc"><a class="xref" href="#/chicondon0016#ch08">8   Why Americans Don’t Look Up</a></p>
<p class="toc"><a class="xref" href="#/chicondon0017#ch09">9   Why Americans Would Rather Look Down</a></p>
<p class="toc"><a class="xref" href="#/chicondon0018#ch10">10   How Looking Up Keeps Us Down</a></p>
<p class="toc"><a class="xref" href="#/chicondon0019#ch11">11   The Power of Social Comparison</a></p>
<p class="tocbmf"><a class="xref" href="#/chicondon0020#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chicondon0021#app">Appendix</a></p>
<p class="tocbm"><a class="xref" href="#/chicondon0022#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chicondon0023#refs">References</a></p>
<p class="tocbm"><a class="xref" href="#/chicondon0024#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-condon-0005.vue?0925b578